const General = require('./en/General.json');

module.exports = {
  translation: {
    ...General
  }
};
